import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-quote-notes-view',
  templateUrl: './quote-notes-view.component.html',
  styleUrls: ['./quote-notes-view.component.scss'],
})
export class QuoteNotesViewComponent  {
  @Input() items: {
    message: string,
    personName: string,
    avatarUrl: string,
    date: Date,
  }[] = [];
}